import React from 'react'
import { renderToString } from 'react-dom/server'
import Typography from '@material-ui/core/Typography'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import useIsMobile from 'components/program-marketing/useIsMobile'
import ReactMarkdown from 'react-markdown'

const TextEllipsisHTML = responsiveHOC()(HTMLEllipsis)

const ReadMore = ({
  text,
  maxLine = 2,
  maxLineMobile = 2,
  basedOn = 'words',
  onClick,
}) => {
  const isMobile = useIsMobile()
  const functionName = 'readMore'
  window[functionName] = onClick

  return (
    <Typography component="span" variant="body1">
      <TextEllipsisHTML
        unsafeHTML={renderToString(<ReactMarkdown>{text}</ReactMarkdown>)}
        maxLine={isMobile ? maxLineMobile : maxLine}
        trimRight
        basedOn={basedOn}
        ellipsisHTML={`... <a style="color: inherit; text-decoration: underline; cursor: pointer;" onclick="window.${functionName}()">Read More</a>`}
      />
    </Typography>
  )
}

export default ReadMore
